import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=517a6fb2&"
import script from "./Packaging.vue?vue&type=script&lang=js&"
export * from "./Packaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517a6fb2')) {
      api.createRecord('517a6fb2', component.options)
    } else {
      api.reload('517a6fb2', component.options)
    }
    module.hot.accept("./Packaging.vue?vue&type=template&id=517a6fb2&", function () {
      api.rerender('517a6fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Study/Packaging.vue"
export default component.exports